export const REQUEST_TIMEOUT = 20_000;
